import { render, staticRenderFns } from "./IconHandshake.vue?vue&type=template&id=35b8a037"
import script from "./IconHandshake.vue?vue&type=script&lang=js"
export * from "./IconHandshake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports